import axios from "../utils/axios";
import { PreferencesData } from "../types/billing";

const billingPath = "billing";
const overviewPath = "/overview";
const preferencesPath = "/preferences";
const paymentMethodsPath = "/payment-methods";
const paymentMethodPath = "/payment-method";
const setDefaultPaymentMethodPath = "/set-default-payment-method";
const subscriptionSetupPath = "/subscription/setup";
const createIntentPath = "/create-intent";
const invoicesPath = "/invoices";
const costPath = "costs";

export const getOverview = () => axios.get(`${billingPath}${overviewPath}`);

export const getPreferences = () => axios.get(`${billingPath}${preferencesPath}`);

export const getPaymentMethods = () => axios.get(`${billingPath}${paymentMethodsPath}`);

export const deletePaymentMethods = (id: string) => axios.delete(`${billingPath}${paymentMethodPath}/${id}`);

export const setDefaultPaymentMethods = (id: string) => axios.put(`${billingPath}${setDefaultPaymentMethodPath}/${id}`);

export const postSubscriptionSetup = (priceIds: string[]) =>
  axios.post(`${billingPath}${subscriptionSetupPath}`, {
    priceIds,
  });

export const postCreateIntent = () => axios.post(`${billingPath}${createIntentPath}`);

export const getInvoices = () => axios.get(`${billingPath}${invoicesPath}`);

export const getCosts = (startDate: string, endDate: string) =>
  axios.get(costPath, {
    params: {
      "start-date": startDate,
      "end-date": endDate,
    },
  });

export const updatePreferences = (data: PreferencesData) =>
  axios.put(`${billingPath}${preferencesPath}`, {
    ...data,
  });
